/* eslint-disable jsx-a11y/anchor-is-valid */
import * as Yup from "yup";
import React, { useState } from "react";
import Loader from "../../Components/Loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { axiosInstance } from "../../Axios/https";
import { toast } from "react-toastify";
import Layout from "../../Components/Layout/Layout";

const ChangePassword = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const initialValues = {
    current_password: "",
    new_password: "",
    confirm_password: "",
  };
  const initialSchema = Yup.object().shape({
    current_password: Yup.string().required("Current Password is required"),
    new_password: Yup.string().required("New Password is required"),
    confirm_password: Yup.string().required("Confirm Password is required"),
  });

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: initialSchema,
      onSubmit: (values) => {
        setLoader(true);
        const formData = new FormData();
        formData.append("current_password", values.current_password);
        formData.append("new_password", values.new_password);
        formData.append("confirm_password", values.confirm_password);
        axiosInstance
          .post(`client/update/password`, formData)
          .then((res) => {
            console.log(res?.data, "res?.data");
            if (res?.data?.status === true) {
              toast.success(res?.data?.message);
              navigate("/");
              setLoader(false);
            } else {
              toast.error(res?.data?.message);
              setLoader(false);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error(err?.response?.data?.message);
            setLoader(false);
          });
      },
    });

  return (
    <>
      <Layout>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Change Password</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Change Password
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h1-story-area two mb-120 pt-120">
          <div className="container">
            <div className="row gy-5 align-items-center justify-content-center">
              <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center">
                <div className="section-title1">
                  <h2>Change Password</h2>
                </div>
                <div className="story-content form-wrapper col-12">
                  <div className="login-section">
                    <div className="container">
                      <div className="row d-flex justify-content-center g-4">
                        <div className="col-xl-12 col-lg-12 col-md-12">
                          <div
                            className="form-wrapper wow fadeInUp shadow-none"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                          >
                            <form className="w-100" onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-inner">
                                    <label>Enter Your Current Password *</label>
                                    <input
                                      type="password"
                                      placeholder="Enter Your Current Password"
                                      name="current_password"
                                      onChange={handleChange}
                                      value={values.current_password}
                                      onBlur={handleBlur}
                                    />
                                    {errors.current_password &&
                                    touched.current_password ? (
                                      <span
                                        className="ms-2"
                                        style={{ color: "red" , fontSize : '16px' }}
                                      >
                                        {errors.current_password}
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-inner">
                                    <label>Enter Your New Password *</label>
                                    <input
                                      type="password"
                                      placeholder="Enter Your New Password"
                                      name="new_password"
                                      onChange={handleChange}
                                      value={values.new_password}
                                      onBlur={handleBlur}
                                    />
                                    {errors.new_password &&
                                    touched.new_password ? (
                                      <span
                                        className="ms-2"
                                        style={{ color: "red" , fontSize : '16px' }}
                                      >
                                        {errors.new_password}
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-inner">
                                    <label>
                                      Enter Your Confirmation Password *
                                    </label>
                                    <input
                                      type="password"
                                      placeholder="Enter Your Confirmation Password"
                                      name="confirm_password"
                                      onChange={handleChange}
                                      value={values.confirm_password}
                                      onBlur={handleBlur}
                                    />
                                    {errors.confirm_password &&
                                    touched.confirm_password ? (
                                      <span
                                        className="ms-2"
                                        style={{ color: "red" , fontSize : '16px' }}
                                      >
                                        {errors.confirm_password}
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <button className="account-btn">
                                {loader ? <Loader /> : "Change Password"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ChangePassword;
